import React, { useEffect, useState } from 'react';
import { Settings, MessageSquare, MapPin, Calendar, Phone, Shield, Database, Trash2, CheckCircle2 } from 'lucide-react';
import { useDataStore } from '../context/DataStoreContext';
export function Config() {
  const {
    leads,
    events,
    qaRecords,
    resetAll
  } = useDataStore();
  const [gcalConnected, setGcalConnected] = useState(false);
  useEffect(() => {
    const connected = localStorage.getItem('growthly_gcal_connected') === 'true';
    setGcalConnected(connected);
  }, []);
  const handleToggleGcal = () => {
    const newState = !gcalConnected;
    setGcalConnected(newState);
    localStorage.setItem('growthly_gcal_connected', String(newState));
  };
  const handleReset = () => {
    if (window.confirm('¿Estás seguro de que quieres borrar TODOS los datos? Esta acción no se puede deshacer y el CRM volverá a estar completamente vacío.')) {
      resetAll();
      window.alert('Datos borrados correctamente. El CRM está vacío.');
    }
  };
  const sections = [{
    title: 'Integraciones',
    icon: <Settings className="w-5 h-5 text-growthly-text" data-id="element-843" />,
    items: [{
      name: 'WhatsApp Business API',
      status: 'Conectado',
      icon: <MessageSquare className="w-4 h-4" data-id="element-844" />,
      action: null
    }, {
      name: 'Google My Business',
      status: 'Conectado',
      icon: <MapPin className="w-4 h-4" data-id="element-845" />,
      action: null
    }, {
      name: 'Google Calendar (Exportación)',
      status: gcalConnected ? 'Conectado' : 'Desconectado',
      icon: <Calendar className="w-4 h-4" data-id="element-846" />,
      action: <button onClick={handleToggleGcal} className={`text-[11px] font-medium px-3 py-1 rounded transition-colors ${gcalConnected ? 'bg-white/10 text-white hover:bg-white/20' : 'bg-growthly-green text-white hover:bg-growthly-green/90'}`} data-id="element-847">
              {gcalConnected ? 'Desconectar' : 'Conectar'}
            </button>
    }, {
      name: 'Telefonía (Twilio)',
      status: 'Pendiente',
      icon: <Phone className="w-4 h-4" data-id="element-848" />,
      action: null
    }]
  }, {
    title: 'Privacidad y GDPR',
    icon: <Shield className="w-5 h-5 text-growthly-text" data-id="element-849" />,
    items: [{
      name: 'Políticas de Retención',
      status: 'Configurado',
      icon: <Database className="w-4 h-4" data-id="element-850" />,
      action: null
    }, {
      name: 'Flujos DSAR (Export/Delete)',
      status: 'Activo',
      icon: <Shield className="w-4 h-4" data-id="element-851" />,
      action: null
    }]
  }];
  return <div className="p-4 md:p-8 max-w-[1100px] mx-auto space-y-6 pb-24 md:pb-8" data-id="element-852">
      <div className="flex items-center justify-between" data-id="element-853">
        <div data-id="element-854">
          <h1 className="text-[28px] font-bold text-growthly-text" data-id="element-855">
            Configuración
          </h1>
          <p className="text-[13px] text-growthly-muted mt-1" data-id="element-856">
            Gestiona integraciones y ajustes del sistema.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-857">
        {sections.map((section, idx) => <div key={idx} className="card overflow-hidden" data-id="element-858">
            <div className="p-4 border-b border-white/5 flex items-center space-x-2 bg-growthly-panel" data-id="element-859">
              {section.icon}
              <h3 className="text-[14px] font-semibold text-growthly-text" data-id="element-860">
                {section.title}
              </h3>
            </div>
            <div className="divide-y divide-white/5" data-id="element-861">
              {section.items.map((item, itemIdx) => <div key={itemIdx} className="p-4 flex items-center justify-between hover:bg-white/[0.02] transition-colors" data-id="element-862">
                  <div className="flex items-center space-x-3" data-id="element-863">
                    <div className="w-8 h-8 rounded bg-white/5 flex items-center justify-center text-growthly-muted" data-id="element-864">
                      {item.icon}
                    </div>
                    <span className="text-[13px] font-medium text-growthly-text" data-id="element-865">
                      {item.name}
                    </span>
                  </div>
                  <div className="flex items-center space-x-3" data-id="element-866">
                    <span className={`text-[11px] font-medium px-2 py-1 rounded ${item.status === 'Conectado' || item.status === 'Activo' || item.status === 'Configurado' ? 'bg-growthly-green/20 text-growthly-green' : 'bg-growthly-amber/20 text-growthly-amber'}`} data-id="element-867">
                      {item.status}
                    </span>
                    {item.action}
                  </div>
                </div>)}
            </div>
          </div>)}

        <div className="card overflow-hidden border-growthly-red/20" data-id="element-868">
          <div className="p-4 border-b border-growthly-red/10 flex items-center space-x-2 bg-growthly-red/5" data-id="element-869">
            <Trash2 className="w-5 h-5 text-growthly-red" data-id="element-870" />
            <h3 className="text-[14px] font-semibold text-growthly-red" data-id="element-871">
              Zona de Peligro
            </h3>
          </div>
          <div className="p-5" data-id="element-872">
            <div className="flex items-center space-x-4 mb-4 text-[13px] text-growthly-muted bg-white/5 p-3 rounded-lg" data-id="element-873">
              <div className="flex flex-col items-center" data-id="element-874">
                <span className="text-[16px] font-bold text-white" data-id="element-875">
                  {leads.length}
                </span>
                <span data-id="element-876">Leads</span>
              </div>
              <div className="w-px h-8 bg-white/10" data-id="element-877"></div>
              <div className="flex flex-col items-center" data-id="element-878">
                <span className="text-[16px] font-bold text-white" data-id="element-879">
                  {events.length}
                </span>
                <span data-id="element-880">Eventos</span>
              </div>
              <div className="w-px h-8 bg-white/10" data-id="element-881"></div>
              <div className="flex flex-col items-center" data-id="element-882">
                <span className="text-[16px] font-bold text-white" data-id="element-883">
                  {qaRecords.length}
                </span>
                <span data-id="element-884">QA</span>
              </div>
            </div>
            <p className="text-[13px] text-growthly-muted mb-4" data-id="element-885">
              Borrar todos los datos del CRM. Esto eliminará todos los leads,
              eventos del calendario, registros de QA y el historial. El CRM
              volverá a su estado inicial vacío.
            </p>
            <button onClick={handleReset} className="bg-growthly-red/10 text-growthly-red hover:bg-growthly-red hover:text-white px-4 py-2 rounded-lg text-[13px] font-medium transition-colors" data-id="element-886">
              Empezar de cero (Borrar todo)
            </button>
          </div>
        </div>
      </div>
    </div>;
}